import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useUser } from "../../../../context/UserContext";
import { fetchOpportunitiesRequest } from "../../../../store/features/actions/opportunities/opportunitesActions";
import { deleteOpportunity, fetchConvertToWin, markReadByUser } from "../../../../services/iqApiV2";

import GenericTable from "../../genericComponents/genericTableComp/GenericTable";
import OpportunityFilterContainer from "./opportunityFilterContainer/OpportunityFilterContainer";

import ContactMapCard from "./CardTabs/ContactMapCard";
import BusinessCaseCard from "./CardTabs/BusinessCaseCard";
import IOSSpinner from "../../../HtmlElements/IOSSpinner";
import ScHeaderComp from "../../genericComponents/genericTableComp/genericTableScHeader/ScHeaderComp";
import TagOverflowHandler from "../../uiUtils/TagOverflowHandler";

import "./SpotOpportunities.css";
import TagOverflowHandlerV2 from "../../uiUtils/TagOverflowHandlerV2";
import GenericOverviewSideCard from "../../genericComponents/GenericOverviewSideCard";
import MemoryContainerSC from "../../../Navigation/memoryComps/MemoryContainerSC";
import ClosureCard from "./CardTabs/ClosureCard";
import { useBanner } from "../../../../context/BannerContext";
import SimpleSearchBar from "../../genericComponents/simpleSearchBar/SimpleSearchBar";
import TR3DotMenu from "../../genericComponents/genericTableComp/TR3DotMenu";
import { useGroupTaskWebSocket } from "../../../../context/GroupTaskWebSocketContext";
import StatusIndicator from "../../genericComponents/resizeableTable/StatusIndicator";
import BattleCardV2 from "./CardTabs/BattleCardV2";

const randomIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" className="top_tab_icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#535458" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
);

function SpotOpportunities() {
  const dispatch = useDispatch();
  const { clientName, accountName } = useParams();
  const { user } = useUser();
  const showBanner = useBanner();
  const { opportunitesData, opportunitesLoading } = useSelector(state => state?.opportunitiesReducer);
  const {getDataById } = useGroupTaskWebSocket();
  const [searchQuery, setSearchQuery] = useState("");
  const [filters, setFilters] = useState({});
  const [filterOptions, setFilterOptions] = useState({});
  const [tabData, setTabData] = useState([]);
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [currRow, setCurrRow] = useState(null);
  const [activeTab, setActiveTab] = useState("");
  const [showMemSc,setShowMemSc]= useState(false);
  // const taskStatus = getTaskStatus(`spot_opp_table`);
  const [selectedOpportunity, setSelectedOpportunity] = useState({
    id: null,
    name: null,
    desc: null,
        mainSignal:null,
    relevanceScore:null
  });
  const liveOpps = getDataById("spot_opp_table")

  useEffect(() => {
    if (clientName && accountName && user?.id) {
      dispatch(fetchOpportunitiesRequest({ clientName, accountName, userId: user.id, type: "spot" }));
    }
  }, [clientName, accountName, user?.id, dispatch]);

  const handleConvertTOWin = useCallback(
    async (item) => {
      const postCall=()=>{
             showBanner({ message: 'Moved To Win Opportunities',title:"Alert", type: 'info', duration: 2000 })
      }
      const resp = await fetchConvertToWin([item?._id], user?.id,postCall);
      if (resp) {
        dispatch(fetchOpportunitiesRequest({ clientName, accountName, userId: user?.id, type: "spot" }));
      }
    },
    [clientName, accountName, user?.id, dispatch]
  );

const handleSideCard = useCallback(
  async (e, item, tabId = "battle_card_so") => {
    e.preventDefault();
    e.stopPropagation();

    setShowMoreModal(true);
    setSelectedOpportunity({
      id: item?._id,
      name: item?.opportunity_name,
      desc: item?.opportunity_description,
      mainSignal: item.tag,
      relevanceScore: item.relevance_score
    });
    setCurrRow(item);
    setActiveTab(tabId);

    try {
      if (item?.is_read === false) {
        const resp = await markReadByUser(user?.id, item?._id);
        if (resp) {
         dispatch(fetchOpportunitiesRequest({ clientName, accountName, userId:user?.id, type: "spot" }));
        }
      }
    } catch (err) {
      console.error("Failed to mark as read:", err);
    }
  },
  [user]
);

  const handleDeleteOpp = useCallback(async (e, userId, item) => {
    e.preventDefault();
    e.stopPropagation();
    const resp=  await deleteOpportunity(userId, item?._id); // Pass params if needed
    if (resp) {
      showBanner({ message: 'Deleted From Spot Opportunities',title:"Alert", type: 'success', duration: 5000 })
      dispatch(fetchOpportunitiesRequest({ clientName, accountName, userId:userId, type: "spot" }));
    }
  }, []);


  const commonProps = useMemo(() => ({
    opportunityId: selectedOpportunity.id,
    opportunityName: selectedOpportunity.name,
    opportunityDescription: selectedOpportunity.desc,
    mainSignal:selectedOpportunity.mainSignal,
    relevanceScore:selectedOpportunity.relevanceScore
  }), [selectedOpportunity]);

  const tabConfig = useMemo(() => [
    { key: "battle_card_so",tabId:"battle_card", label: "Battle Card", Component: () => <BattleCardV2 mainSignal={commonProps.mainSignal} opportunityId={commonProps.opportunityId}  relevanceScore={commonProps.relevanceScore}/>, icon: randomIcon, tagIcon:<img src="/img/blueDocIcon.png" width="16"/>  },
    { key: "contact_map_so",tabId:"contact_map", label: "Contact Map", Component: () => <ContactMapCard {...commonProps} />, icon: randomIcon,  tagIcon:<img src="/img/blueDocIcon.png" width="16"/>},
    // { key: "business_case_so",tabId:"business_case", label: "Business Case", Component: () => <BusinessCaseCard {...commonProps} />, icon: randomIcon, tagIcon:<img src="/img/blueDocIcon.png" width="16"/> },
    // ...(clientName === "MARKETS & MARKETS" ? [{ key: "closure_note_so",tabId:"closure_note", label: "Closure Note", Component: () => <ClosureCard {...commonProps} />, icon: randomIcon, tagIcon:<img src="/img/blueDocIcon.png" width="16"/> }] : []),
  ], [commonProps]);

  useEffect(() => {
    if (!opportunitesData?.length) return;

    let filtered = opportunitesData?.filter(item =>
      Object.entries(filters).every(([key, values]) => {
        // special case
        if (key === "solution_names") {
          console.log("solution_names", key, values, item);
          const val = item?.["solution_names"] || [];
          return val?.[0]?.some(v => values.includes(v));
        }
        if (!values?.length) return true;
        const val = item[key.toLowerCase()] || item[key];
        return values.includes(val);
      })
    );
    // Apply search filter on opportunity_name and tag
    if (searchQuery) {
      const query = searchQuery?.toLowerCase();
      filtered = filtered.filter(item =>
        item.opportunity_name?.toLowerCase().includes(query) ||
        item.tag?.toLowerCase().includes(query)||
        item.match?.toLowerCase().includes(query)
      );
    }
    const enhanced = filtered.map(item => ({
      ...item,
      opportunity_name:<div onClick={(e)=>handleSideCard(e, item)}>{item.opportunity_name}</div>,
      contact_count: <div className="opp-user-icon-container" onClick={(e)=>handleSideCard(e, item)}><img src="/img/users.png" alt="users" className="mr-1"/> {item.contact_count}</div>,
      relevance_score: item?.relevance_score && <div onClick={(e)=>handleSideCard(e, item)}>{item?.relevance_score}%</div>,
      tag:  <div onClick={(e)=>handleSideCard(e, item)}><TagOverflowHandlerV2 data={item?.tag}/></div>,
      documents: <TagOverflowHandler handleSideCard={handleSideCard} tabConfig={tabConfig} rowData={item}/>,
      actions: (
        <button className="convert-to-win-btn" onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleConvertTOWin(item);
        }}>
          <div><img src="/img/Forward.png" alt="move" className="mr-1" width="14"/></div>
          <div>{opportunitesLoading ? <IOSSpinner/> :<>Move To Win</>}</div>
        </button>
      ),
      saveFav: <TR3DotMenu  menuItems={[
            { label: "Delete", onMenuClick: (e) =>handleDeleteOpp(e,user?.id,item) }
          ]} />,
    }));

    setTabData(enhanced);
  }, [opportunitesData, filters, handleConvertTOWin, handleSideCard, tabConfig,searchQuery]);

  useEffect(() => {

    const hasPending = liveOpps.some((element) => element.status === "pending");

    setTabData((prev) => {
      // Remove any existing isPartialLoad rows first
      const cleaned = prev?.filter((item) => !item?.isPartialLoad) || [];

      if (hasPending) {
        // Add isPartialLoad at the top
        return [
          {
            isPartialLoad: (
              <td colSpan={7} className="gtr-expanded-cell">
                <StatusIndicator text="Adding new Opportunities" />
              </td>
            ),
          },
          ...cleaned,
        ];
      } else {
        return cleaned;
      }
    });


    liveOpps.forEach((item,idx)=>{
      if ((item?.status == "completed" || item?.status =="failed") && liveOpps?.length>0 ) {
        console.log("called spot through live ",idx)
        setTimeout(() => {
           dispatch(fetchOpportunitiesRequest({ clientName, accountName, userId: user.id, type: "spot" }));
        }, 2000);
             
      }

    })
    
  }, [liveOpps?.length]);


  

useEffect(() => {
  // Exit early if there's no data to process
  if (!opportunitesData?.length) return;

  // Define the keys we're interested in extracting values from
  const include = ['tag', 'solution_names'];

  // Initialize an object to collect unique filter values
  const options = {};

  // Loop through each opportunity item
  opportunitesData.forEach(item => {
    include.forEach(key => {
      const value = item[key];
      if (!value) return; // Skip if key doesn't exist or is null/undefined

      // Initialize a Set for the key if not already present
      options[key] = options[key] || new Set();

      // Special case: if key is "solution_names", assume nested array structure
      if (key === "solution_names") {
        // Expected structure: solution_names: [[...]]
        value?.[0]?.forEach(val => options[key].add(val));
      }
      // Handle general arrays
      else if (Array.isArray(value)) {
        value.forEach(val => options[key].add(val));
      }
      // Handle primitive or single string values
      else {
        options[key].add(value);
      }
    });
  });

  // Convert each Set to an array for easier use in dropdowns, filters, etc.
  const formatted = Object.entries(options).reduce((acc, [key, val]) => {
    acc[key] = [...val];
    return acc;
  }, {});

  // Debug output
  console.log("formatted", formatted);

  // Set the final structured filter options in state
  setFilterOptions(formatted);
}, [opportunitesData]);


  const tableColumns = useMemo(() => [
    { id: "opportunity_name", label: "Opportunity", width: 130 },
    { id: "tag", label: "Signal", width: 100 },
    { id: "contact_count", label: "Contacts", width: 60 },
    { id: "relevance_score", label: "Match", width: 50 },
    { id: "documents", label: "Documents", width: 120 },
    { id: "actions", label: "Actions", width: 100 },
    { id: "saveFav", label: "", width: 28, clickAction: true },
  ], []);

  const filterCount = useMemo(() =>
    Object.values(filters).reduce((acc, val) => acc + (val?.length || 0), 0)
  , [filters]);

  return (
    <>
      <OpportunityFilterContainer
        filterOptions={filterOptions}
        filters={filters}
        setFilters={setFilters}
        type="spot"
        chatbotBtnTxt=" Find / Add Opportunity "
        mainTitl="Spot Opportunities before your peers do"
        filterTitl="Filter Opportunities by Solutions,Signals. "
        oppBtnTitl="Or Generate Battle Card, Contact map for your opportunity"
      />

      <div className="find-opportunities-container mounted">
        <span className="find-opportunities-header-container">
          <span className="find-opportunities-header">
            <h6 className="find-opportunities-results-title">
            Showing {opportunitesLoading ? <IOSSpinner /> : tabData?.length || 0} Results
            </h6>

            {filterCount > 0 && (
              <div className="find-opportunities-results-title-filter-badge">
                {filterCount} filters applied
                <img src="/img/x.png" alt="clear" onClick={() => setFilters({})} />
              </div>
            )}
          </span>
        <span style={{display:"flex",justifyContent:"center",flexDirection:"row",alignItems:"center"}}>
            <SimpleSearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
            {/* <button
              className="memory_btn_trans"
              onClick={(e) => {
                e.preventDefault();
                setShowMemSc(prev => !prev);
                dispatch(listGlobalMemRequest({ userId: user?.id, memoryType: "opportunity" }));
              }}
            >
              <img src="/img/plus1.png" className="memory_icon" alt="memory" />
              Memory
            </button> */}
          </span>
        </span>

        <div className="find-opportunities-results-container">
          <GenericTable
            initialColumns={tableColumns}
            tabData={tabData}
            sideCardTabConfig={tabConfig}
            showMoreModal={showMoreModal}
            setShowMoreModal={setShowMoreModal}
            titleForSideCard={
              <ScHeaderComp
                key={`side_card_head_comp_${commonProps?.opportunityId}`}
                type="spot_opportunities" 
                showMoreModal={showMoreModal} 
                data={currRow} 
                setShowMoreModal={setShowMoreModal} 
                opportunityId={commonProps?.opportunityId} 
                tabConfig={tabConfig} 
                showMemComp={true} 
                memoryType={"single-opportunity"} 
              />}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            loading={opportunitesLoading && tabData?.length==0}
          />
        </div>
      </div>


      <GenericOverviewSideCard
        showMoreModal={showMemSc}
        setShowMoreModal={setShowMemSc}
        titleForSideCard={<div className='mem-sc-titl-cont'><img className='back-btn-img' src="/img/backArrow.png" onClick={()=>setShowMoreModal(false)}/> <span className="span_memory">Memory</span></div>}
        comp={<MemoryContainerSC memoryType="opportunity"/>}
        minWidthForDrawer="30%"
        disableXbtn
        />
    </>
  );
}

export default SpotOpportunities;
